export class BasemapConstant {
  static readonly GOOGLE_MAPS = 'google-maps';
  static readonly GOOGLE_SATELLITE = 'google-satellite';
  static readonly GOOGLE_HYBRID = 'google-hybrid';
  static readonly GOOGLE_TERRAIN = 'google-terrain';

  static readonly BING_MAPS = 'bing-maps';
  static readonly BING_SATELLITE = 'bing-satellite';

  static readonly ARCGIS_LIGHT_GRAY = 'arcgis-light-gray';
  static readonly ARCGIS_VECTOR = 'arcgis-vector';
  static readonly ARCGIS_STREETS = 'arcgis-streets';
  static readonly ARCGIS_SATELLITE = 'arcgis-satellite';
  static readonly ARCGIS_TOPO = 'arcgis-topo';
  static readonly ARCGIS_DARK_GRAY = 'arcgis-dark-gray';
  static readonly ARCGIS_NAVIGATION = 'arcgis-navigation';
  static readonly ARCGIS_HYBRID = 'arcgis-hybrid';

  static readonly OSM_STANDARD = 'osm-standard';
  static readonly OSM_HUMANITARIAN = 'osm-humanitarian';
  static readonly OSM_DE = 'osm-de';

  static readonly ESRI_STREETS = 'esri-streets';
  static readonly ESRI_IMAGERY = 'esri-imagery';
  static readonly ESRI_TOPO = 'esri-topo';
  static readonly ESRI_DARK_GRAY = 'esri-dark-gray';
  static readonly ESRI_LIGHT_GRAY = 'esri-light-gray';
  static readonly ESRI_NAVIGATION = 'esri-navigation';

  static readonly CARTODB_POSITRON = 'cartodb-positron';
  static readonly CARTODB_DARK_MATTER = 'cartodb-dark-matter';

  static readonly STAMEN_TONER = 'stamen-toner';
  static readonly STAMEN_WATERCOLOR = 'stamen-watercolor';
  static readonly STAMEN_TERRAIN = 'stamen-terrain';

  static readonly OPEN_TOPO_MAP = 'open-topo-map';
  static readonly USGS_TOPO = 'usgs-topo';
  static readonly CYCLOSM = 'cyclosm';
  static readonly WIKIMEDIA = 'wikimedia';
  static readonly MTB_MAP = 'mtb-map';
}
